import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CourseCard from '../CourseCard';
import Carousel from '../Carousel';
import styles from 'LearningManager/styles/QuickSetup.module.scss';
import { Icon } from 'Components';
import CourseDetailModal, { LanguageTags } from '../CourseDetailModal';
import { courseDetailMockData } from 'LearningManager/constants/createAssignment.constant';
import useLanguageNames from 'LearningManager/hooks/useLanguageNames';

interface Props {
	id?: string;
	title: string;
	duration: string;
	description: string;
	courses: any[];
	language_ids?: number[];
}

const LearningSection: React.FC<Props> = ({
	id,
	title,
	duration,
	description,
	courses,
	language_ids = []
}) => {
	const [showDetails, setShowDetails] = useState(false);
	const [detailActivityId, setDetailActivityId] = useState<
		number | undefined
	>(undefined);
	const getLanguageNames = useLanguageNames();
	const { t } = useTranslation();
	const activityLanguages = getLanguageNames(language_ids).map((label) => ({ label }));

	return (
		<div id={id} className={styles.learningSection}>
			<div className={styles.sectionHeader}>
				<div className={styles.headingContainer}>
					<Icon type="pathIcon" role="img" />
					<div>{title}</div>
					<div className={styles.duration}>
						<Icon type="clockIcon" role="img" /> {duration}
					</div>
				</div>
				<div className={styles.description}>{description}</div>
			</div>

			{activityLanguages.length ? <div className={styles.languageContainer}>
				<LanguageTags languages={activityLanguages} label={t('learning.viewDetails.languages')} />
			</div> :  null}
			<Carousel
				data={courses}
				itemsPerPage={4}
				overlayControls
				renderItem={(course, position) => (
					<CourseCard
						key={course.id}
						course={course}
						index={position + 1}
						onClick={() => {
							setDetailActivityId(course.id);
							setShowDetails(true);
						}}
						hideMandatoryCover
					/>
				)}
			/>

			<CourseDetailModal
				visible={showDetails}
				onClose={() => setShowDetails(false)}
				activityId={detailActivityId}
				{...courseDetailMockData}
			/>
		</div>
	);
};

export default LearningSection;
